module.exports = __webpack_public_path__ + "static/media/innov_4.8d9ff259.jpg";